export default {
  items: [
    /*
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    */
    {
      name: 'Conversazioni',
      url: '/messages/0',
      icon: 'icon-user',
      badge: {
        variant: 'primary',
        //text: 'NEW'
      }
    }
  ]
}
